<template>
    <a-modal
            :title="title"
            :width="640"
            :visible="visible"
            :confirmLoading="confirmLoading"
            okText="确定"
            cancelText="取消"
            @ok="handleSubmit"
            @cancel="handleCancel"
    >
        <a-spin :spinning="confirmLoading">
            <a-form :form="form">
                <a-form-item
                        label="原密码"
                        required
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input-password
                            type="oldPassword"
                            placeholder="输入原密码"
                            v-decorator="['oldPassword', {rules: [{required: true, message: `请输入原密码`}]}, ]" />
                </a-form-item>
                <a-form-item
                        label="新密码"
                        required
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input-password
                            type="newPassword"
                            placeholder="输入新设置的密码"
                            v-decorator="['newPassword', {rules: [{required: true, message: `请输入新设置密码`}]}, ]" />
                </a-form-item>
                <a-form-item
                        label="确认新密码"
                        required
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input-password
                            type="retypePassword"
                            placeholder="再输入一遍新设置的密码"
                            v-decorator="['retypePassword', {rules: [{required: true, message: `请再输入一遍新设置的密码`}]}, ]" />
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script>
    import md5 from 'md5'
    import vendorAdminService from "../service/vendorAdmin";

    export default {
        data () {
            return {
                // formModal统一数据
                visible: false,
                title: "密码修改",
                confirmLoading: false,
                form: this.$form.createForm(this),

                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 7 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 13 }
                },
            }
        },
        methods: {
            showForm() {
                this.form.resetFields()
                this.visible = true
            },

            handleSubmit () {
                const { form: { validateFields } } = this
                this.confirmLoading = true
                validateFields((errors, values) => {
                    if(values.retypePassword !== values.newPassword) {
                        this.$message.error("两次输入的密码需保持一致！")
                        this.confirmLoading = false
                        return
                    }
                    if(values.newPassword.length < 6) {
                        this.$message.error("密码长度不能小于6")
                        this.confirmLoading = false
                        return
                    }
                    if (!errors) {
                        vendorAdminService.changePassword({
                            oldPassword: md5(values.oldPassword),
                            newPassword: md5(values.newPassword)
                        }).then(()=>{
                            this.confirmLoading = false
                            this.visible = false
                            this.$message.success("密码修改成功！")
                        }).catch(()=>{
                            this.confirmLoading = false
                        })
                    } else {
                        this.confirmLoading = false
                    }
                })
            },
            handleCancel () {
                this.visible = false
            }
        },
    }
</script>
